import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authModule';
import SearchableTradeList from 'ah-trades/src/components/lists/SearchableTradeList.vue';
import ActivityTradeListFilters from 'ah-trades/src/components/lists/ActivityTradeListFilters.vue';
import { clientTradeStates, clientTradeStatus, fxHedgingInstruments } from 'ah-api-gateways';
import { computed } from 'vue';
import { partnerTradeReportTableFieldsFull } from 'ah-trades/src/models/tradeTableFields';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityTradesView',
  setup(__props) {

const authStore = useAuthStore();

const partnerId = computed(() => {
  return authStore.loggedInIdentity?.partner.id;
});

const config = computed(() => {
  return { tableFields: partnerTradeReportTableFieldsFull };
});

const possibleStates = computed(() => clientTradeStates);

const possibleStatuses = computed(() => clientTradeStatus);

const possibleInstruments = computed(() => fxHedgingInstruments);

return { __sfc: true,authStore, partnerId, config, possibleStates, possibleStatuses, possibleInstruments, SearchableTradeList, ActivityTradeListFilters }
}

})